import { createContext } from "react";

type DisableFactorSetupContextType = {
  disableFactorSetup: boolean;
  setDisableFactorSetup: (disableFactorSetup: boolean) => void;
};

const DisableFactorSetupContext = createContext<DisableFactorSetupContextType>({
  disableFactorSetup: false,
  setDisableFactorSetup: () => undefined,
});

export default DisableFactorSetupContext;
